<script setup>
import {inject, onMounted, ref, nextTick} from 'vue';
  const videoRef = ref(null);
  const progressRef = ref(null);
  const paused = ref(true);
  const currentTime = ref('00:00');
  const videoUrl = inject('url');
  const translations = inject('translations');
  const timePercentage = ref(0);

  function playVideo() {
    if (videoRef.value.paused) {
      videoRef.value.play();
    }
    else {
      videoRef.value.pause();
    }
  }

  function pauseEvent() {
    paused.value = true;
  }

  function playingEvent() {
    paused.value = false;
  }

  function rewindVideo() {
    videoRef.value.currentTime = videoRef.value.currentTime - 3 < 0 ? 0 : videoRef.value.currentTime -3;
  }

  function forwardVideo() {
    const currentTime = videoRef.value.currentTime;
    videoRef.value.currentTime = currentTime + 3 > videoRef.value.duration ? videoRef.value.duration : currentTime + 3;
  }

  function stopVideo() {
    videoRef.value.pause();
    videoRef.value.currentTime = 0;
  }

  function updateTime() {
    const minutes = Math.floor(videoRef.value.currentTime/60);
    const seconds = Math.floor(videoRef.value.currentTime % 60);
    currentTime.value = `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
    timePercentage.value = (videoRef.value.currentTime / videoRef.value.duration * 100);
  }

  function updateProgress(event) {
    const rect = progressRef.value.getBoundingClientRect();
    if (event) {
      const clickX = event.clientX - rect.left;
      const progressBarWidth = rect.width;
      let percentage = clickX / progressBarWidth * 100;
      progressRef.value.value = percentage;
      videoRef.value.currentTime = videoRef.value.duration * (percentage / 100);
    }
  }

</script>

<template>
  <section data-component="video">
    <video ref="videoRef" @pause="pauseEvent" @playing="playingEvent" @click="playVideo" data-component="cmp-video" data-controls="true" @timeupdate="updateTime">
    <source :src="videoUrl" type="video/mp4">
    </video>
      <div class="overlay-play yt-play-button" :class="!paused && 'visually-hidden'" @click="playVideo"
           :aria-label="paused ? translations.play : translations.pause">
        <svg xmlns="http://www.w3.org/2000/svg" width="90" height="90" viewBox="0 0 90 90" fill="none">
          <g filter="url(#filter0_b_3256_62)">
            <path d="M45 85C55.6087 85 65.7828 80.7857 73.2843 73.2843C80.7857 65.7828 85 55.6087 85 45C85 34.3913 80.7857 24.2172 73.2843 16.7157C65.7828 9.21427 55.6087 5 45 5C34.3913 5 24.2172 9.21427 16.7157 16.7157C9.21427 24.2172 5 34.3913 5 45C5 55.6087 9.21427 65.7828 16.7157 73.2843C24.2172 80.7857 34.3913 85 45 85ZM65 45L32.5 65V25L65 45Z" fill="black" fill-opacity="0.65"/>
            <path d="M45 87.5C56.2717 87.5 67.0817 83.0223 75.052 75.052C83.0223 67.0817 87.5 56.2717 87.5 45C87.5 33.7283 83.0223 22.9183 75.052 14.948C67.0817 6.97767 56.2717 2.5 45 2.5C33.7283 2.5 22.9183 6.97767 14.948 14.948C6.97767 22.9183 2.5 33.7283 2.5 45C2.5 56.2717 6.97767 67.0817 14.948 75.052C22.9183 83.0223 33.7283 87.5 45 87.5ZM35 29.4739L60.2299 45L35 60.5261V29.4739Z" stroke="white" stroke-opacity="0.05" stroke-width="5"/>
          </g>
          <g filter="url(#filter1_b_3256_62)">
            <path d="M32.7419 65V25L65 44.887L32.7419 65Z" fill="white" fill-opacity="0.9"/>
          </g>
          <defs>
            <filter id="filter0_b_3256_62" x="-13" y="-13" width="116" height="116" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
              <feFlood flood-opacity="0" result="BackgroundImageFix"/>
              <feGaussianBlur in="BackgroundImageFix" stdDeviation="6.5"/>
              <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_3256_62"/>
              <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_3256_62" result="shape"/>
            </filter>
            <filter id="filter1_b_3256_62" x="-21.2581" y="-29" width="140.258" height="148" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
              <feFlood flood-opacity="0" result="BackgroundImageFix"/>
              <feGaussianBlur in="BackgroundImageFix" stdDeviation="27"/>
              <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_3256_62"/>
              <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_3256_62" result="shape"/>
            </filter>
          </defs>
        </svg>
      </div>

      <div class="controls">
        <button class="playpause fa fass" :class="paused ? 'fa-play' : 'fa-pause'" @click="playVideo"
                :aria-label="paused ? translations.play : translations.pause">
        </button>
        <button class="stop fa fass fa-stop" @click="stopVideo" :aria-label="translations.stop"></button>
        <button class="rwd fa fass fa-fast-backward" @click="rewindVideo" :aria-label="translations.rewind"></button>
        <button class="fwd fa fass fa-fast-forward" @click="forwardVideo" :aria-label="translations.forward"></button>
        <div class="video-progress"><progress ref="progressRef" @click="updateProgress" max="100" :value="timePercentage"></progress></div>
        <div class="time">{{ currentTime }}</div>
      </div>

  </section>
</template>
